export default "__VITE_ASSET__e40bf5a4__"